module.exports = "<span class=\"total\">{{$ctrl.data.pagos_completados + ' / ' + $ctrl.total}}</span>\r\n<div class=\"barra\">\r\n  <div ng-repeat=\"item in $ctrl.totales track by $index\"\r\n      ng-style=\"{width: (item.valor * 100) + '%', backgroundColor: item.color}\"></div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/dispersion/pagos/progreso/template.html
// module id = 1228
// module chunks = 0